import React from "react";
import ExchangeRate from "state/ExchangeRate";
import { ExchangeRateContext } from "state/Contexts";

export default function useExchangeRate(): ExchangeRate {
    return React.useContext(ExchangeRateContext);
}
